import React from 'react'

const UploadVideos = () => {
  return (
    <div className='text-md mt-3 text-center'>Coming Soon</div>
  )
}

export default UploadVideos